import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "37"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18 2.48c-9.098 0-16.5 7.403-16.5 16.5v.003c0 2.976.788 5.768 2.168 8.178l-.043-.081-2.1 7.489a.716.716 0 0 0 .69.911h.001a1 1 0 0 0 .172-.02l7.817-1.936c2.255 1.232 4.94 1.956 7.794 1.957 9.098 0 16.5-7.402 16.5-16.5s-7.402-16.5-16.5-16.5H18Zm8.3 22.323c-.353.977-2.046 1.868-2.86 1.989-.73.107-1.654.153-2.668-.166a25 25 0 0 1-2.415-.88c-4.25-1.813-7.024-6.038-7.236-6.316-.213-.278-1.73-2.268-1.73-4.326s1.094-3.07 1.482-3.49a1.56 1.56 0 0 1 1.13-.523c.282 0 .564.004.812.015.26.012.61-.098.954.718.353.838 1.2 2.895 1.305 3.106s.177.454.036.733c-.14.28-.21.454-.423.699s-.446.546-.636.733c-.212.209-.433.436-.185.854.247.419 1.097 1.789 2.357 2.898 1.617 1.426 2.983 1.867 3.406 2.076s.67.174.917-.105c.246-.28 1.059-1.222 1.34-1.64.283-.419.566-.35.954-.21.389.14 2.471 1.152 2.894 1.36.423.21.706.315.813.49.105.172.105 1.01-.247 1.987z"
    }, null, -1)
  ])))
}
export default { render: render }